import React from 'react'
import UpdateBulkTransactionsFlyout from 'src/app/UpdateBulkTransactionsFlyout/UpdateBulkTransactionsFlyout'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateBulkTransactionsRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateBulkTransactionsAppRoute: AppRoute = {
  id: AppLocation.UpdateBulkTransactions,
  routeProps: updateBulkTransactionsRouteProps,
  component: <UpdateBulkTransactionsFlyout />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateBulkTransactionsAppRoute
